module.exports = __webpack_public_path__ + "media/svgs/PDF-Icon-red-ec15dd9611f7a2e643d2d383a0170b70.svg";